module.exports = __webpack_public_path__ + "static/img/12.4f1d39c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/12.png
// module id = Zx36
// module chunks = 0